import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import _ from "lodash";
import { connect } from "react-redux";
import UserBar from "../common/UserBar";
import { availableFeedCardPostTypes } from "../../../../utils/commonVariables";
import CompanyBar from "../common/CompanyBar";
import MetaBar from "../common/MetaBar";
import PostComments from "../common/PostComments";
import { Link } from "react-router-dom";
import {
    GIF_TYPE,
    decodeString,
    getYoutubeThumbnail,
    isYoutubeVideo,
    removeStripTags,
    makePlaylistForJWPlayer,
} from "../../../../utils/helper";
import { certificateLinks, surveyLinks } from "../../../../utils/internalLinks";
import ReadMoreLinkified from "../common/ReadMoreLinkified";
import ReadMoreText from "../common/ReadMoreText";
import PaidRibbon from "../../../../components/profile/MyPassbook/PaidRibbon";
import { left } from "@popperjs/core";
import CommonPlayer from "../../../../components/CommonPlayer";
function CertificationCard(props) {
    const {
        cardData,
        isShared,
        showOptionsIcon,
        hideMetaBar,
        isAd,
        showFlagOptions,
        user,
        commentsData,
    } = props,
        { certification, meta, shared } = cardData,
        postId = get(certification, "id"),
        createdAt = certification.created_at,
        title = decodeString(get(certification, "title", "")),
        description = removeStripTags(decodeString(certification.description), ["br"]);
    const linkToCertification = certificateLinks.single(postId);
    const imageMeta = _.get(certification, 'image_meta', "");
    const imagesMeta = _.isString(imageMeta) ? JSON.parse(imageMeta) : imageMeta;
    const videoMeta =
        certification.video_meta && typeof certification.video_meta === "string"
            ? JSON.parse(certification.video_meta)
            : certification.video_meta;
    const uploadedVideos = get(certification, "videos_meta", []);
    const imageToShow =
        imagesMeta && imagesMeta.length && imagesMeta[0].original_photo
            ? imagesMeta[0].original_photo
            : videoMeta &&
                videoMeta.length &&
                videoMeta[0].url &&
                isYoutubeVideo(videoMeta[0].url)
                ? getYoutubeThumbnail(isYoutubeVideo(videoMeta[0].url), "high")
                : null;
    const gifImage =
        certification.image_meta &&
            certification.image_meta.length &&
            certification.image_meta[0].meta &&
            certification.image_meta[0].meta.mime == GIF_TYPE
            ? true
            : false;
    const isPaid = get(meta, "isPaid", "");


    return (
        <div className="feed-card">
            <Link to={linkToCertification} className="certification__card">

                {imageToShow ? (
                    <img
                        src={imageToShow}
                        className={
                            gifImage
                                ? "certification__card__img big_gif_image background_gif "
                                : "certification__card__img"
                        }
                        alt={title}
                        style={{
                            border: gifImage ? "1px solid #D1D1D1" : null,
                            left: gifImage ? "-17px" : null,
                            // objectFit: !isYoutubehas ? "contain" : null,
                        }}
                    />
                ) : (
                    uploadedVideos &&
                    !!uploadedVideos.length &&
                    uploadedVideos.map((video) => {
                        const playlist = makePlaylistForJWPlayer(
                            get(video, "media_json", [])
                        );
                        return (
                            <div
                                key={`feed-card-${postId}`}
                                onClick={(e) => e.preventDefault()}
                                className="certification__card__wrapper"
                            >
                                <CommonPlayer
                                    playerId={`feed-card-${postId}-${isShared ? `shared-card-${shared.id}` : ''}`}
                                    videosMeta={[video] || []}
                                    withoverlay={false}
                                />
                            </div>
                        );
                    })
                )}
                <div className="certification__card__details cursor-pointer">
                    {isPaid && (
                        <div className="feedcardribbon__certification__ribbon">
                            <PaidRibbon />
                        </div>
                    )}
                    <h2 className="certification__card__header">Certification</h2>
                    <ReadMoreLinkified
                        text={title}
                        linksAsDiv={true}
                        className="certification__card__title"
                        hashtagEventLabel="Survey"
                    />
                    <ReadMoreText
                        text={description}
                        className="certification__card__description"
                    />
                    <button className="certification__card__btn">SEE More</button>
                </div>
            </Link>
            {!isShared && !hideMetaBar && cardData.meta && (
                <MetaBar
                    postType={availableFeedCardPostTypes.certification}
                    postId={postId}
                    isAd={isAd}
                    likeActionProcessing={cardData.likeActionProcessing}
                    fetchingComments={commentsData && commentsData.fetching}
                    postToShare={cardData}
                    meta={cardData.meta}
                />
            )}
            {commentsData && !hideMetaBar && !isShared && (
                <PostComments
                    showOptionsIcon={showOptionsIcon}
                    commentsData={commentsData}
                    postType={availableFeedCardPostTypes.certification}
                    isAd={isAd}
                    postId={postId}
                />
            )}
        </div>
    )
}


export default CertificationCard;